
import { api } from '../common/globals';
export const getObjectiveSpecial = (objective,user, token) => 
        fetch(api+`/reporte/especial/validMovistar/?objectiveId=${objective}&user=${user}&token=${token}`)
        .then(response => response.json())



// WEBPACK FOOTER //
// ./src/services/getObjectiveSpecial.jsx